(function () {
  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function translateRecoverError(msg) {
    var lower = String(msg || '').toLowerCase();
    if (lower.indexOf('too many attempts') !== -1 || lower.indexOf('too many tries') !== -1) {
      return '送信回数が上限に達しました。しばらく時間をおいてから再度お試しください。';
    }
    if (lower.indexOf('not found') !== -1) {
      return '入力されたメールアドレスは登録されていません。';
    }
    if (lower.indexOf('enter a valid email') !== -1 || lower.indexOf('email is invalid') !== -1) {
      return '有効なメールアドレスを入力してください。';
    }
    if (lower.indexOf('blank') !== -1 || lower.indexOf('required') !== -1) {
      return 'メールアドレスを入力してください。';
    }
    return msg || '送信に失敗しました。しばらくしてから再度お試しください。';
  }

  function parseRecoverErrorsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var out = [];
    doc.querySelectorAll('.errors li, .ktob-form-errors li').forEach(function (li) {
      var text = (li.textContent || '').trim();
      if (text) out.push(translateRecoverError(text));
    });
    if (out.length) return out;

    var bodyText = ((doc.body && doc.body.textContent) || html || '').replace(/\s+/g, ' ');
    if (/too many attempts/i.test(bodyText)) {
      return ['送信回数が上限に達しました。しばらく時間をおいてから再度お試しください。'];
    }
    if (/something went wrong/i.test(bodyText)) {
      return ['送信に失敗しました。しばらくしてから再度お試しください。'];
    }
    return [];
  }

  function isRecoverSuccess(response, html) {
    if (response.status === 302 || response.status === 303) return true;
    if (response.type === 'opaqueredirect') return true;
    if (response.redirected && /\/account\/login/.test(response.url || '')) return true;
    var lower = String(html || '').toLowerCase();
    return (
      lower.indexOf("we've sent you an email") !== -1 ||
      lower.indexOf('sent you an email') !== -1 ||
      lower.indexOf('リセット用メール') !== -1 ||
      lower.indexOf('メールを送信') !== -1
    );
  }

  function showRecoverErrors(container, messages) {
    if (!container) return;
    var existing = container.querySelector('[data-ktob-recover-errors]');
    if (existing) existing.remove();
    if (!messages.length) return;
    var box = document.createElement('div');
    box.className = 'errors ktob-form-errors';
    box.setAttribute('data-ktob-recover-errors', '');
    box.innerHTML =
      '<ul>' +
      messages
        .map(function (msg) {
          return '<li>' + escapeHtml(msg) + '</li>';
        })
        .join('') +
      '</ul>';
    var form = container.querySelector('form') || container;
    if (form.firstChild) {
      form.insertBefore(box, form.firstChild);
    } else {
      form.appendChild(box);
    }
  }

  function readEmailFromForm(form) {
    if (!form) return '';
    var input =
      form.querySelector('input[name="email"]') ||
      form.querySelector('input[type="email"]') ||
      form.querySelector('#KtobRecoverEmail') ||
      form.querySelector('#RecoverEmail');
    return input ? String(input.value || '').trim() : '';
  }

  function checkRecoverEmail(options) {
    var email = options && options.email;
    var proxyUrl = (options && options.proxyUrl) || '/apps/b2b-gate';
    return fetch(proxyUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        intent: 'check-recover-email',
        email: email,
      }),
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            return { httpOk: response.ok, body: body || {} };
          });
      })
      .then(function (result) {
        var body = result.body || {};
        if (body.ok && body.status === 'ready') {
          return { ok: true, status: 'ready', message: body.message || '' };
        }
        var message =
          body.message ||
          body.error ||
          'メールアドレスを確認できませんでした。しばらくしてから再度お試しください。';
        return {
          ok: false,
          status: body.status || 'error',
          message: message,
          registerUrl: options && options.registerUrl,
        };
      })
      .catch(function () {
        return {
          ok: false,
          status: 'error',
          message: 'メールアドレスを確認できませんでした。しばらくしてから再度お試しください。',
        };
      });
  }

  function submitShopifyRecover(form) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'manual',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (isRecoverSuccess(response, '')) {
        return { ok: true };
      }
      return response.text().then(function (html) {
        if (isRecoverSuccess(response, html)) {
          return { ok: true };
        }
        var errors = parseRecoverErrorsFromHtml(html);
        if (!errors.length) {
          errors = ['送信に失敗しました。しばらくしてから再度お試しください。'];
        }
        return { ok: false, errors: errors };
      });
    });
  }

  function submitForm(options) {
    var form = options && options.form;
    if (!form) return Promise.resolve();

    var submitBtn = form.querySelector('button[type="submit"]');
    var errorHost = (options && options.errorHost) || form;
    var email = readEmailFromForm(form);
    showRecoverErrors(errorHost, []);

    if (!email) {
      var blankErrors = ['メールアドレスを入力してください。'];
      if (options.onError) options.onError(blankErrors);
      else showRecoverErrors(errorHost, blankErrors);
      return Promise.resolve();
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.ktobOrigText = submitBtn.textContent;
      submitBtn.textContent = '確認中…';
    }

    return checkRecoverEmail({
      email: email,
      proxyUrl: (options && options.proxyUrl) || '/apps/b2b-gate',
      registerUrl: options && options.registerUrl,
    })
      .then(function (check) {
        if (!check.ok) {
          var checkErrors = [check.message];
          if (options.onError) options.onError(checkErrors, check);
          else showRecoverErrors(errorHost, checkErrors);
          return { ok: false, stopped: true };
        }
        if (submitBtn) submitBtn.textContent = '送信中…';
        return submitShopifyRecover(form);
      })
      .then(function (result) {
        if (!result || result.stopped) return;
        if (result.ok) {
          if (options.onSuccess) options.onSuccess();
          return;
        }
        if (options.onError) {
          options.onError(result.errors || []);
        } else {
          showRecoverErrors(errorHost, result.errors || []);
        }
      })
      .catch(function () {
        var errors = ['送信に失敗しました。しばらくしてから再度お試しください。'];
        if (options.onError) {
          options.onError(errors);
        } else {
          showRecoverErrors(errorHost, errors);
        }
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.ktobOrigText || 'リセット用メールを送信';
        }
      });
  }

  window.ktobRecoverPassword = {
    submitForm: submitForm,
    showErrors: showRecoverErrors,
    translateRecoverError: translateRecoverError,
    parseRecoverErrorsFromHtml: parseRecoverErrorsFromHtml,
    checkRecoverEmail: checkRecoverEmail,
  };
})();
